import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";
import AxiosInterceptor from "../../Services/axiosIntercepter";

const createData = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

const updateData = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.put(url, body);
  return result;
};

const sendEmail = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

export function* DONOR_PERSONAL_DETAILS_SAGA() {
  yield takeEvery(
    actions.DONOR_PERSONAL_DETAILS_CREATE_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(createData, payload);
        if (res.data.status_code === 1) {
          localStorage.setItem("donorId", res?.data?.data?._id);
          sessionStorage.setItem("donor-Id", res?.data?.data?._id);

          yield put({
            type: actions.DONOR_PERSONAL_DETAILS_CREATE_SUCCESS,
            message: res.data?.message,
            status_code: res.data?.status_code,
          });
        } else {
          yield put({
            type: actions.DONOR_PERSONAL_DETAILS_CREATE_ERROR,
            message: res?.data?.message || "Failed to create the donor.",
            status_code: res.data.status_code,
          });
        }
      } catch (error) {
        yield put({
          type: actions.DONOR_PERSONAL_DETAILS_CREATE_ERROR,
          message: error?.data?.message || "Failed to create the donor.",
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

export function* updateDonorDetails() {
  yield takeEvery(
    actions.DONOR_DETAILS_UPDATE_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(updateData, payload);
        if (res.data.status_code === 1) {
          localStorage.setItem("donorId", res?.data?.data?._id);
          yield put({
            type: actions.DONOR_DETAILS_UPDATE_SUCCESS,
            message: res.data?.message,
            status_code: res.data?.status_code,
          });
        } else {
          yield put({
            type: actions.DONOR_DETAILS_UPDATE_ERROR,
            message: res?.data?.message,
            status_code: res.data.status_code,
          });
        }
      } catch (error) {
        yield put({
          type: actions.DONOR_DETAILS_UPDATE_ERROR,
          message: "Failed to update donor details",
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

export function* CreateDonationDetails() {
  yield takeEvery(
    actions.DONATION_DETAILS_CREATE_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(createData, payload);
        if (res.data.status_code === 1) {
          localStorage.setItem("donorId", res?.data?.data?.donor_id);
          sessionStorage.setItem("donor-Id", res?.data?.data?.donor_id);

          yield put({
            type: actions.DONATION_DETAILS_CREATE_SUCCESS,
            successMessage: res.data?.message,
            status_code: res.data?.status_code,
          });
        } else {
          yield put({
            type: actions.DONATION_DETAILS_CREATE_ERROR,
            errorMessage: res?.data?.message,
            status_code: res.data.status_code,
          });
        }
      } catch (error) {
        yield put({
          type: actions.DONATION_DETAILS_CREATE_ERROR,
          errorMessage: error?.data?.message,
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

export function* sendMailrequest() {
  yield takeEvery(
    actions.SEND_MAIL_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(sendEmail, payload);
        if (res?.data) {
          yield put({
            type: actions.SEND_MAIL_REQUEST_SUCCESS,
            successMessage: res.data?.message,
          });
        } else {
          yield put({
            type: actions.SEND_MAIL_REQUEST_ERROR,
            errorMessage: res?.data?.message,
          });
        }
      } catch (error) {
        yield put({
          type: actions.SEND_MAIL_REQUEST_ERROR,
          errorMessage: error?.data?.message,

        });
      }
    }
  );
}

export default function* rootSaga() {
  yield all([
    fork(DONOR_PERSONAL_DETAILS_SAGA),
    fork(CreateDonationDetails),
    fork(updateDonorDetails),
    fork(sendMailrequest),
  ]);
}
